import type { TokenScope } from '@dynamic-labs/sdk-api-core';

import { getDefaultClient } from '../../../client/defaultClient';
import { verifyWalletAccountForSignInOrTransfer } from '../verifyWalletAccountForSignInOrTransfer';
import type { WalletAccount } from '../walletAccount';

type VerifyWalletAccountParams = {
  requestedScopes?: TokenScope[];
  walletAccount: WalletAccount;
};

/**
 * Verifies ownership of a wallet account and adds it to the user's profile.
 *
 * This function requires the user to sign a message to prove wallet ownership,
 * then sets the wallet account as verified.
 *
 * @param params.walletAccount - The wallet account to verify ownership of.
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns A promise that resolves to the verified wallet account.
 * @throws WalletAccountAlreadyVerifiedError If the wallet is already verified.
 * @throws WalletAlreadyLinkedToAnotherUserError If the wallet is linked to another user.
 */
export const verifyWalletAccount = async (
  { walletAccount, requestedScopes }: VerifyWalletAccountParams,
  client = getDefaultClient()
): Promise<WalletAccount> => {
  return verifyWalletAccountForSignInOrTransfer(
    {
      isTransfer: false,
      requestedScopes,
      walletAccount,
    },
    client
  );
};
